import $ from 'jquery';
import 'devbridge-autocomplete';

$(function() {
	const el = '#service-map';
	var $el = $(el);
	if ($el.length < 1) return false;

	var request = {};
	request.items = $el.attr('data-map-data');
	if (!request.items) return false;

	function setMapHeight() {
		var windowHeight = window.innerHeight;
		var mapOffset = $el.offset().top;
		$el.css('min-height', windowHeight - mapOffset + 'px');
	}

	// setMapHeight();

	// $(window).resize(function() {
	//   setMapHeight();
	// })

	$.get(request.items, {}, createMap);

	function createMap(config) {
		ymaps.ready().then(function () {
			const map = new ymaps.Map($(el).attr('id'), {
				center: [+config.center[0], +config.center[1]],
				zoom: +config.zoom,
				controls: []
			}, {
				suppressMapOpenBlock: true
			});

			const zoomControl = new ymaps.control.ZoomControl({
				options: {
					layout: 'round#zoomLayout',
					position: {
						top: '.5rem',
						right: '.5rem'
					}
				}
			});
			map.controls.add(zoomControl);

			const geolocationControl = new ymaps.control.GeolocationControl({
				options: {
					layout: 'round#buttonLayout',
					position: {
						top: 'calc(80px + .5rem + 8px)',
						right: '.5rem'
					}
				}
			});
			map.controls.add(geolocationControl);

			geolocationControl.events.add('click', function (event) {
				ymaps.geolocation
				.get({
					autoReverseGeocode: false
				})
				.then(
					(result) => {
						map.panTo(result.geoObjects.get(0).geometry.getCoordinates());
					},
					(err) => {
						console.log('Ошибка: ' + err)
					}
				);
			});

			const clusterer = new ymaps.Clusterer({
				groupByCoordinates: false,
				clusterDisableClickZoom: false,
				clusterHideIconOnBalloonOpen: false,
				geoObjectHideIconOnBalloonOpen: false,
				clusterIcons: [{
					href: config.icons.cluster.iconImageHref,
					size: [+config.icons.cluster.iconImageSize[0], +config.icons.cluster.iconImageSize[1]],
					offset: [+config.icons.cluster.iconImageOffset[0], +config.icons.cluster.iconImageOffset[1]]
				}],
				clusterIconContentLayout: ymaps.templateLayoutFactory.createClass('<span style="color: white; font-size: 12px; font-weight: bold;">{{properties.geoObjects.length}}</span>')
			});

			const placemarkStyle = {
				default: {
					iconLayout: 'default#image',
					iconImageHref: config.icons.default.iconImageHref,
					iconImageSize: [+config.icons.default.iconImageSize[0], +config.icons.default.iconImageSize[1]],
					iconImageOffset: [+config.icons.default.iconImageOffset[0], +config.icons.default.iconImageOffset[1]]
				},
				active: {
					iconLayout: 'default#image',
					iconImageHref: config.icons.active.iconImageHref,
					iconImageSize: [+config.icons.active.iconImageSize[0], +config.icons.active.iconImageSize[1]],
					iconImageOffset: [+config.icons.active.iconImageOffset[0], +config.icons.active.iconImageOffset[1]]
				}
			};

			const geoObjs = [];
			for (var i = 0; i < config.collection.length; i++) {
				geoObjs.push(new ymaps.Placemark(
					[+config.collection[i].geo[0], +config.collection[i].geo[1]],
					{
						id: config.collection[i].id,
						city: config.collection[i].city,
						brands: config.collection[i].brands,
						types: config.collection[i].types,
						hintContent: config.collection[i].name,
						balloonContentHeader: `<span class="map-service-balloon-header">${config.collection[i].name}</span>`,
						balloonContentBody: `<div class="map-service-balloon-content">${config.collection[i].balloon}</div>`,
						hideIconOnBalloonOpen: false
					},
					placemarkStyle.default
				));
			}
			clusterer.add(geoObjs);
			map.geoObjects.add(clusterer);
			map.setBounds(clusterer.getBounds());

			function setPlacemarksDefault() {
				clusterer.getGeoObjects().forEach(function(object) {
					object.options.set(placemarkStyle.default);
				});
			}

			clusterer.events.add('click', function (e) {
				const target = e.get('target');
				setPlacemarksDefault();
				if (typeof target.getGeoObjects == 'undefined') {
					target.options.set(placemarkStyle.active);
				}
			});

			const filterStates = {
				city: false,
				brands: false,
				types: false
			}
			const $brands = $('[data-service-map-filter-brands]');
			const $types = $('[data-service-map-filter-types]');
			const $city = $('#service-map-filter-city');
			const $cityEmpty = $('#service-map-filter-city-clear');

			$brands.change(function() {
				const checked = [];

				$brands.each(function() {
					const $this = $(this);
					if ($this.prop('checked')) {
						checked.push($this.attr('data-service-map-filter-brands'));
					}
				});

				filterStates.brands = checked.length > 0 ? checked : false;
				filter();
			});

			$types.change(function() {
				const checked = [];

				$types.each(function() {
					const $this = $(this);
					if ($this.prop('checked')) {
						checked.push($this.attr('data-service-map-filter-types'));
					}
				});

				filterStates.types = checked.length > 0 ? checked : false;
				filter();
			});

			$city.devbridgeAutocomplete({
				lookup: config.cities,
				onSelect: function(suggestion) {
					filterStates.city = suggestion.data;
					filter();
				}
			});

			$cityEmpty.click(() => {
				$city.val('');
				filterStates.city = false;
				filter();
			});

			function filter() {
				const newGeoObjs = [];

				geoObjs.forEach(function(object) {
					const isMatched = {
						city: true,
						brands: true,
						types: true
					}
					let fullyMatched = true;

					function checkMatch(id) {
						const prop = object.properties.get(id);

						if (typeof prop == 'object') {
							for (let i = 0; i < filterStates[id].length; i++) {
								if (!prop.includes(filterStates[id][i])) {
									isMatched[id] = false;
									break;
								}
							}
						} else if (typeof prop == 'string') {
							if (prop != filterStates[id]) isMatched[id] = false;
						}
					}

					for (let key in filterStates) {
						if (filterStates[key]) checkMatch(key);
					}

					for (let key in isMatched) {
						if (!isMatched[key]) {
							fullyMatched = false;
							break;
						}
					}

					if (fullyMatched) newGeoObjs.push(object);
				});

				setPlacemarksDefault();
				clusterer.removeAll();
				if (newGeoObjs.length > 0) {
					clusterer.add(newGeoObjs);
					map.geoObjects.add(clusterer);
					map.setBounds(clusterer.getBounds(), {
						checkZoomRange: true
					});
				} else {
					map.setCenter([+config.center[0], +config.center[1]], +config.zoom, {
						checkedZoomRange: true
					});
				}
			}
		});
	}
});
